import React from 'react';
import { Box, Typography, Avatar } from '@mui/material';
import {
  RecordVoiceOver as RecordVoiceOverIcon,
  Person as PersonIcon,
  Schedule as ScheduleIcon,
} from '@mui/icons-material';
import { getAllSpeakings, deleteSpeaking } from '../../api/speakingApi';
import { formatDateUK } from '../../utils/dateUtils';
import { GenericListPage } from '../../components/templates';

const SpeakingList = () => {
  const columns = [
    {
      field: 'instructor',
      headerName: 'Instructor',
      flex: 1,
      renderCell: (params) => (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          <Avatar
            sx={{
              backgroundColor: 'info.main',
              width: 32,
              height: 32,
              fontSize: '0.875rem',
            }}
          >
            <PersonIcon />
          </Avatar>
          <Typography variant="body2" sx={{ fontWeight: 500 }}>
            {params.row.instructor?.name || params.row.instructorId || 'N/A'}
          </Typography>
        </Box>
      ),
    },
    {
      field: 'startsAt',
      headerName: 'Start Time',
      flex: 1,
      renderCell: (params) => (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <ScheduleIcon sx={{ color: 'primary.main', fontSize: 16 }} />
          <Typography variant="body2" sx={{ fontWeight: 500 }}>
            {params.value ? formatDateUK(new Date(params.value)) : 'N/A'}
          </Typography>
        </Box>
      ),
    },
    {
      field: 'endsAt',
      headerName: 'End Time',
      flex: 1,
      renderCell: (params) => (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <ScheduleIcon sx={{ color: 'success.main', fontSize: 16 }} />
          <Typography variant="body2" sx={{ fontWeight: 500 }}>
            {params.value ? formatDateUK(new Date(params.value)) : 'N/A'}
          </Typography>
        </Box>
      ),
    },
  ];

  return (
    <GenericListPage
      title="Speaking Sessions"
      subtitle="Manage speaking sessions and instructor assignments"
      icon={<RecordVoiceOverIcon />}
      entityName="Speaking Session"
      columns={columns}
      fetchData={getAllSpeakings}
      deleteItem={deleteSpeaking}
      createPath="/speakings/new"
      editPath="/speakings"
    />
  );
};

export default SpeakingList;
